import React, { useState, useEffect } from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import logo from './assets/logo.png';
import './Header.css'


function Header() {
	const navigate = useNavigate();
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	
	useEffect(() => {
		const checkAuth = () => {
		const token = localStorage.getItem('token');
			setIsAuthenticated(!!token);
		};

		checkAuth();
	}, []);
	
	const handleSignOut = () => {
        localStorage.removeItem('token');
		setIsAuthenticated(false);
		navigate("/login")
    };

    const signOutButtonStyle = {
        visibility: isAuthenticated ? 'visible' : 'hidden'
    };
    return (
        <Navbar>
            <Container fluid style={{ backgroundColor: '#F0F0F0' }}>
                <Navbar.Brand href="/">
                    <img
                        src={logo}
                        width="200"
                        height="120"
                        className="d-inline-block align-top"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto"></Nav>
                    <Nav className="justify-content-center" style={{ width: "100%" }}>
                        <Navbar.Text>
                            <h3 className="title">INFRAGRI Viewer</h3>
                        </Navbar.Text>
                    </Nav>
                    <Nav style={signOutButtonStyle}>
						<Nav.Link href="#" onClick={handleSignOut}>
							<FontAwesomeIcon icon={faSignOutAlt} className="signout"/> 
							<span style={{color:'#233D62'}}> Sign Out </span>
						</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;